import React, { useState, useEffect } from 'react';
import Style from './Navbar.module.css';
import { Link, useLocation } from 'react-router-dom';
import logo from '../../assets/images/logo.png';

const featureLinks = [
  { path: '/invoicing', label: 'Invoicing' },
  { path: '/recurring-billing', label: 'Recurring Invoicing' },
  { path: '/payments', label: 'Payments' },
  { path: '/accounting', label: 'Accounting' },
  { path: '/advisors', label: 'Advisors' },
  { path: '/payyitme', label: 'Fyntiq.Me Lynk' },
];

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isFeaturesOpen, setIsFeaturesOpen] = useState(false);
  const dashboardUrl = process.env.REACT_APP_DASHBOARD_URL;
  const location = useLocation();

  useEffect(() => {
    setIsMenuOpen(false);
    setIsFeaturesOpen(false);
  }, [location.pathname]);

  return (
    <header className={Style.Navbar__Wrapper}>
      <div className={Style.container}>
        <div className={Style.navInner}>
          <Link to="/" className={Style.wordmark}>
            <img
              src={logo}
              alt="Fyntiq Business"
              className={Style.wordmarkImg}
              height={28}
              decoding="async"
            />
          </Link>

          <button
            type="button"
            className={Style.Navbar__Toggle}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            <i className={`fa-regular ${isMenuOpen ? 'fa-times' : 'fa-bars'}`} />
          </button>

          <nav role="navigation" className={`${Style.navLinks} ${isMenuOpen ? Style.navLinksOpen : ''}`}>
            {/* <button
              type="button"
              className={`${Style.navLink} ${Style.hideMobile}`}
              onClick={() => window.dispatchEvent(new CustomEvent('openChargeLookup'))}
            >
              Charge Lookup
            </button> */}

            <div className={Style.featuresItem}>
              <button
                type="button"
                className={`${Style.featuresToggle} ${isFeaturesOpen ? Style.featuresToggleOpen : ''}`}
                onClick={() => setIsFeaturesOpen(!isFeaturesOpen)}
              >
                <span className={Style.navLink}>Features</span>
                <i className="fa-solid fa-angle-down" />
              </button>
              <ul className={`${Style.featuresDropdown} ${isFeaturesOpen ? Style.featuresDropdownOpen : ''}`}>
                {featureLinks.map(({ path, label }) => (
                  <li key={path} className={location.pathname === path ? Style.Active : ''}>
                    <Link className={Style.navLink} to={path}>{label}</Link>
                  </li>
                ))}
              </ul>
            </div>

            <Link
              className={Style.navLink}
              to="/pricing"
            >
              Pricing
            </Link>

            <span className={`${Style.navDivider} ${Style.hideMobile}`} />

            <Link className={Style.btnGhost} to={`${dashboardUrl}/signin`}>Sign in</Link>
            <Link className={Style.btnInk} to={`${dashboardUrl}/signup`}>Get started</Link>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
